import { RecordContextProvider, TextInput, useTranslate } from 'react-admin';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import EditableField from '@/components/global/fields/EditableField.jsx';
const HeaderEditableTitle = ({ isEditingTitle, onEdit }) => {
    const translate = useTranslate();
    const name = useWatch({ name: 'name' });

    const recordValue = useMemo(() => ({ id: 'new', name: name ?? translate('resources.campaign.labels.newCampaignName') }), [name, translate]);

    return (
        <RecordContextProvider value={recordValue}>
            <EditableField
                label=''
                isEditing={isEditingTitle}
                onEdit={onEdit}
                displayValue={record => record?.name ?? translate('resources.campaign.labels.newCampaignName')}
                isFilled={record => Boolean(record?.name)}
                isHorizontal={true}
                tooltipTitle={translate('resources.campaign.labels.nameTooltip')}
                sx={{
                    '& .RaLabeled-label': { display: 'none' },
                    '& .ra-field': { margin: 0 },
                    '& .MuiButtonBase-root': {
                        marginLeft: '20px',
                    },
                    '& .MuiFormHelperText-root': {
                        display: 'none',
                    },
                    '& .editable-field-content': {
                        fontFamily: 'Rubik, Arial, sans-serif',
                        fontSize: '28px',
                        fontWeight: 700,
                        lineHeight: 1.2,
                    },
                }}
                editComponent={<TextInput source='name' variant='outlined' size='small' fullWidth />}
            />
        </RecordContextProvider>
    );
};

export default HeaderEditableTitle;
